/* 引数に与えられたテキストにハイフンがあるかを確認する */
export const isIncludeHyphen = (text: string | null | undefined) => {
  if (!text) {
    return false;
  }
  return text.includes('-');
};
